<template>
  <b-container>
    <b-input-group prepend="Bezirk:" class="mt-3">
      <b-form-select
        v-model="selected_bezirke"
        :options="options_bezirke"
      ></b-form-select>
      <b-input-group-append>
        <b-button variant="info" v-on:click="fetchData">
          <b-icon-arrow-repeat></b-icon-arrow-repeat>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-input-group prepend="Zeitraum:" class="mt-3">
      <b-form-select
        v-model="selected_zeitraum"
        :options="options_zeitraum"
      ></b-form-select>
      <b-input-group-append>
        <b-button variant="info" v-on:click="fetchData">
          <b-icon-arrow-repeat></b-icon-arrow-repeat>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <section v-if="errored">
      <b-card bg-variant="danger" text-variant="white" class="text-center my-3">
        <b-card-title>Error</b-card-title>
        <b-card-text
          >We're sorry, we're not able to retrieve this information at the
          moment, please try again later.
        </b-card-text>
      </b-card>
    </section>

    <section v-else>
      <b-card v-if="loading" class="my-3">
        <b-overlay :show="true" no-wrap> </b-overlay>
      </b-card>

      <b-card
        v-else-if="info.cnt_einsaetze === 0"
        bg-variant="success"
        text-variant="white"
        class="text-center my-3"
      >
        <b-card-title>Info</b-card-title>
        <b-card-text>
          Keine laufende Einsätze
        </b-card-text>
      </b-card>

      <template v-else>
        <h1 class="mb-1 mt-2">Aktuelle Einsätze ({{ info.cnt_einsaetze }}):</h1>

        <b-card
          v-for="einsaetze in info.einsaetze"
          v-bind:key="einsaetze.num1"
          bg-variant="dark"
          text-variant="white"
          class="mb-3"
        >
          <b-card-title>
            {{ einsaetze.einsatz.einsatzort }}
            <b-badge pill variant="danger" v-b-tooltip.hover title="Alarmstufe">
              {{ einsaetze.einsatz.alarmstufe }}
            </b-badge>
          </b-card-title>

          <b-card-sub-title class="mb-2">
            {{ einsaetze.einsatz.einsatztyp.text }}
          </b-card-sub-title>

          <b-card-text>
            <b-media no-body class="mb-1">
              <b-media-aside class="mt-1 mr-2">
                <b-icon-clock></b-icon-clock>
              </b-media-aside>
              <b-media-body>
                <ul class="list-unstyled mb-0">
                  <li class="mb-0"><span v-b-tooltip.hover title="Startzeit">{{ einsaetze.einsatz.startzeit | formatDate("datetime") }}</span></li>
                </ul>
              </b-media-body>
            </b-media>

            <b-media no-body class="mb-1">
              <b-media-aside class="mt-1 mr-2">
                <b-icon-info-circle></b-icon-info-circle>
              </b-media-aside>
              <b-media-body>
                <ul class="list-unstyled mb-0">
                  <li><span v-b-tooltip.hover title="Einsatzart">{{ einsaetze.einsatz.einsatzart }}</span></li>
                  <li><span v-b-tooltip.hover title="Einsatzsubtyp">{{ einsaetze.einsatz.einsatzsubtyp.text }}</span></li>
                  <li><span>Anzahl der Feuerwehren: {{ einsaetze.einsatz.cntfeuerwehren }}</span></li>
                </ul>
              </b-media-body>
            </b-media>

            <b-media no-body>
              <b-media-aside class="mt-1 mr-2">
                <b-icon-house></b-icon-house>
              </b-media-aside>
              <b-media-body>
                <ul class="list-unstyled mb-0">
                  <li><span v-b-tooltip.hover title="Adresse">{{ einsaetze.einsatz.adresse.default | isNullStr }}</span></li>
                  <li><span v-b-tooltip.hover title="Gemeinde">{{ einsaetze.einsatz.adresse.emun | isNullStr }}</span></li>
                  <li><span v-b-tooltip.hover title="Adresszusatz">{{ einsaetze.einsatz.adresse.ecompl | isNullStr }}</span></li>
                  <li><span v-b-tooltip.hover title="Bezirk">{{ einsaetze.einsatz.bezirk.text | isNullStr }}</span></li>
                </ul>
              </b-media-body>
            </b-media>
          </b-card-text>
          <b-button-group>
            <b-button
              :to="{
                name: 'Detail',
                params: { einsatzNum: einsaetze.einsatz.num1 }
              }"
              variant="primary"
            >
              <b-icon-search></b-icon-search> Details
            </b-button>

            <b-button
              target="_blank"
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                  einsaetze.einsatz.wgs84.lat +
                  ',' +
                  einsaetze.einsatz.wgs84.lng
              "
              variant="info"
            >
              <b-icon-map></b-icon-map> Auf der Karte anzeigen
            </b-button>
          </b-button-group>
        </b-card>
      </template>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "Home",

  data() {
    return {
      //API_URL: "https://intranet.ooelfv.at/webext2/api/getjson.php?scope=", OLD API
      API_URL: "https://vanora.eu/feuerwehr/api/proxy/einsaetze/",
      info: null,
      loading: true,
      errored: false,
      selected_zeitraum: "laufend",
      options_zeitraum: [
        { value: "laufend", text: "Laufende Einsätze" },
        { value: "6stunden", text: "Letzten 6 Stunden" },
        { value: "taeglich", text: "Aktueller Tag" },
        { value: "2tage", text: "Letzten 2 Tage" }
      ],
      selected_bezirke: null,
      options_bezirke: [
        { value: null, text: "Alle" },
        { value: "0", text: "Braunau" },
        { value: "1", text: "Eferding" },
        { value: "2", text: "Freistadt" },
        { value: "3", text: "Gmunden" },
        { value: "4", text: "Grieskirchen" },
        { value: "5", text: "Kirchdorf" },
        { value: "6", text: "Linz-Land" },
        { value: "7", text: "Perg" },
        { value: "8", text: "Ried" },
        { value: "9", text: "Rohrbach" },
        { value: "10", text: "Schärding" },
        { value: "11", text: "Steyr-Land" },
        { value: "12", text: "Urfahr-Umgebung" },
        { value: "13", text: "Vöcklabruck" },
        { value: "14", text: "Wels-Land" },
        { value: "15", text: "Steyr-Stadt" },
        { value: "16", text: "Wels-Stadt" },
        { value: "17", text: "Linz-Stadt" }
      ]
    };
  },

  mounted() {
    this.fetchData();

    const tmpBezirk = Number(this.$route.params.bezirk);
    if (Number.isNaN(tmpBezirk)) {
      this.selected_bezirke = null;
    } else {
      if (tmpBezirk >= 0 && tmpBezirk <= 17) {
        this.selected_bezirke = tmpBezirk;
      } else {
        this.selected_bezirke = null;
      }
    }
  },

  watch: {
    selected_zeitraum: function() {
      this.fetchData();
    },
    selected_bezirke: function() {
      if (this.$route.params.bezirk != this.selected_bezirke) {
        this.$router.push({
          name: "Root",
          params: { bezirk: this.selected_bezirke }
        });
      }

      if (
        this.selected_bezirke !== null &&
        this.selected_bezirke >= 0 &&
        this.selected_bezirke <= 17
      ) {
        this.selected_zeitraum = "taeglich";
        this.options_zeitraum = [
          { value: "laufend", text: "Laufende Einsätze" },
          { value: "6stunden", text: "Letzten 6 Stunden" },
          { value: "taeglich", text: "Aktueller Tag" },
          {
            value: "2tage",
            text: "Letzten 2 Tage (Nur mit allen Bezirken möglich)",
            disabled: true
          }
        ];
      } else {
        this.options_zeitraum = [
          { value: "laufend", text: "Laufende Einsätze" },
          { value: "6stunden", text: "Letzten 6 Stunden" },
          { value: "taeglich", text: "Aktueller Tag" },
          { value: "2tage", text: "Letzten 2 Tage" }
        ];
      }
      this.fetchData();
    }
  },

  filters: {
    formatDate(date, mode) {
      if (date == null || date == "") {
        return "";
      }

      var dt = new Date(date);
      var d = dt.getDate();
      var m = dt.getMonth() + 1;
      var Y = dt.getFullYear();
      var h = dt.getHours();
      var i = dt.getMinutes();

      if (d < 10) {
        d = "0" + d;
      }
      if (m < 10) {
        m = "0" + m;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (i < 10) {
        i = "0" + i;
      }

      if (mode == "datetime") {
        return d + "." + m + "." + Y + ", " + h + ":" + i + " Uhr";
      } else {
        return h + ":" + i + " Uhr";
      }
    },
    capitalizeFirstLetter(str) {
      if (str == null) {
        return "";
      }

      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    isNullStr(str) {
      if (str == null || str == "" || str == " ") {
        return "-";
      }
      return str;
    }
  },

  methods: {
    fetchData() {
      this.loading = true;
      this.errored = false;
      var tmpAPI_URL = "";

      if (this.selected_bezirke === null) {
        tmpAPI_URL = this.API_URL + this.selected_zeitraum;
      } else {
        tmpAPI_URL =
          this.API_URL + this.selected_zeitraum + "/" + this.selected_bezirke;
      }

      this.axios
        .get(tmpAPI_URL)
        .then(response => {
          /*var tmp = response.data.replace("callback(", "");
          tmp = tmp.substring(0, tmp.length - 2);
          this.info = JSON.parse(tmp);*/
          this.info = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
